import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_82anes87bj: FaireBrandEntity = {
  token: "b_82anes87bj",
  type: "brand",
  name: "By Odiri",
  avatarUrl:
    "https://cdn.faire.com/fastly/61e8765b81a37395c7a586a95244e13ba830d0de08908b6b4bc89a73d42c6bc0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f9bcbebddce00b769840fdbf55419c349e57a5b77b79136d70baacb091ea15c.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/61e8765b81a37395c7a586a95244e13ba830d0de08908b6b4bc89a73d42c6bc0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f9bcbebddce00b769840fdbf55419c349e57a5b77b79136d70baacb091ea15c.webp",
  location: "Houston, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "At By Odiri, we help you reclaim your space—and your peace. We’re a home decor and candle brand devoted to helping busy professionals and modern homebodies transform their environments into intentional sanctuaries. Our products are more than decor—they're daily invitations to slow down, recharge, and reconnect.\n\nRooted in a belief that your home should support your well-being, we craft eco-conscious candles, decor, and self-care essentials that bring calm, warmth, and elevated style to your space. Every candle is hand-poured using sustainable coconut wax and infused with clean aromatherapy blends—like soothing lavender and grounding sandalwood—to help you unwind, naturally.\n\nOur aesthetic is cozy and mindful, designed to complement your routine without adding noise. Whether you're managing the chaos of work-from-home life or simply craving more stillness, BYODIRI makes it easy to curate a space that nurtures your body, mind, and spirit.\n\nWe’re here to support your evolution—from just existing at home to truly living in it.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.893Z",
    importedBy: "entity-db-cli",
  },
};
